"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeFullName = void 0;
var computeFullName = function (firstName, lastName) {
    var fullName = '';
    if (firstName != null && firstName !== '') {
        fullName += firstName;
    }
    if (lastName != null && lastName !== '') {
        if (fullName.length > 0) {
            fullName += ' ';
        }
        fullName += lastName;
    }
    return fullName;
};
exports.computeFullName = computeFullName;
